module.exports = __webpack_public_path__ + "media/images/sampleBet__kranz-7b3d30a93f9c2223f4d0dd7c366ffa6c.png";